import ScrollDirection from "../core/constants/ScrollDirection";

const SCROLL_DOWN = 'SCROLL_DOWN';
const SCROLL_UP = 'SCROLL_UP';


const handleScrollUp = () => ({
    type: SCROLL_UP,
    payload: {
        direction: ScrollDirection.UP
    },
});

const handleScrollDown = () => ({
    type: SCROLL_DOWN,
    payload: {
        direction: ScrollDirection.DOWN
    },
});

export {
    SCROLL_UP,
    SCROLL_DOWN,
    handleScrollUp,
    handleScrollDown,
}
